/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';

export function Preloader() {
  return <div className="preloader">
    <div className="spinner"/>
  </div>;
}



// WEBPACK FOOTER //
// ./src/app/components/Preloader.tsx